import ComponentLoader from 'components/ComponentLoader'
import React from 'react'

function importWorkoutsComponentRouteUtil () {
  return import(/* webpackChunkName: "pages/Workouts" */ 'pages/Workouts')
}

export default function getWorkoutsComponentRouteUtil (props) {
  if (WORKOUTS || (SERVER && global.WORKOUTS)) {
    const Component = require('pages/Workouts').default
    return <Component {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={importWorkoutsComponentRouteUtil}
        {...props}
      />
    )
  }
}
